module.exports = __webpack_public_path__ + "static/media/slider3.2231e833.png";